export const memberOrderSessionKey = "memberOrderSession";
